import { Badge } from "@/components/ui/badge";
import { Megaphone } from "lucide-react";
import { ProfileAvatar } from "./ProfileAvatar";

interface ProfileHeaderProps {
  fullName: string | null;
  headline: string | null;
  avatarUrl: string | null;
  categoryName?: string;
  isHiring?: boolean;
  availabilityStatus?: string;
}

export const ProfileHeader = ({ 
  fullName, 
  headline, 
  avatarUrl, 
  categoryName,
  isHiring,
  availabilityStatus 
}: ProfileHeaderProps) => {
  const getAvailabilityColor = (status: string) => {
    switch (status) {
      case 'available':
        return 'bg-green-500';
      case 'busy':
        return 'bg-yellow-500';
      case 'not_available':
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };

  // Function to get only first and last name
  const getDisplayName = (name: string | null) => {
    if (!name) return 'Anonymous Artist';
    const names = name.split(' ');
    if (names.length === 1) return names[0];
    return `${names[0]} ${names[names.length - 1]}`;
  };

  return (
    <div className="flex items-center space-x-4">
      <ProfileAvatar avatarUrl={avatarUrl} fullName={fullName} />
      <div className="flex-1">
        <div className="flex items-center justify-between">
          <div className="text-lg font-semibold">
            {getDisplayName(fullName)}
          </div>
          <div className="flex items-center gap-2">
            {isHiring && (
              <Badge variant="success" className="flex items-center gap-1">
                <Megaphone className="h-3 w-3" />
                <span>Open Audition</span>
              </Badge>
            )}
            <div className={`h-2 w-2 rounded-full ${getAvailabilityColor(availabilityStatus || '')}`} />
          </div>
        </div>
      </div>
    </div>
  );
};